export const FETCH_CONFIG_PENDING = 'FETCH_CONFIG_PENDING';
export const FETCH_CONFIG_SUCCESS = 'FETCH_CONFIG_SUCCESS';
export const FETCH_CONFIG_ERROR = 'FETCH_CONFIG_ERROR';

export function fetchConfigPending() {
  return {
    type: FETCH_CONFIG_PENDING
  };
}

export function fetchConfigSuccess(config) {
  return {
    type: FETCH_CONFIG_SUCCESS,
    payload: config
  }
}

export function fetchConfigError(error) {
  return {
    type: FETCH_CONFIG_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/actions/config.js